import { NoticeLoginApp } from '@navio/nsdk';
import { noddiAsync, URLKeys } from 'noddi-async';
import { NoticeBannerList, NoticeTopBanner, useLoginNotices } from 'noddi-web';
import { useCurrentBrand } from '../../stores/BrandStore/brandStore';
import { getNoticeBannerTranslations } from '../../utils/commonTranslations';

const bannerClassName = 'mx-auto flex w-full max-w-5xl flex-col gap-2 px-4 pt-2';

/** Login notices for this brand. The login endpoint applies the opt-in. */
const useCustomerLoginNotices = () => {
  const { currentBrand } = useCurrentBrand();
  const { data: brand, isPending: isBrandPending } = noddiAsync.useGet({
    type: URLKeys.getByDomainBrand,
    input: { brandDomain: currentBrand }
  });
  const notices = useLoginNotices(NoticeLoginApp.CUSTOMER, {
    brandId: brand?.id,
    enabled: !isBrandPending
  });

  return { isBrandPending, ...notices };
};

export const CustomerLoginNoticeTopBanner = () => {
  const { isBrandPending, error, top } = useCustomerLoginNotices();

  if (isBrandPending || error) {
    return null;
  }

  return <NoticeTopBanner notices={top} translations={getNoticeBannerTranslations()} />;
};

export const CustomerLoginNoticeBanner = () => {
  const { isBrandPending, error, content } = useCustomerLoginNotices();

  if (isBrandPending || error) {
    return null;
  }

  return (
    <NoticeBannerList notices={content} className={bannerClassName} translations={getNoticeBannerTranslations()} />
  );
};
